<script>
  import { onMount } from "svelte";

  export let isTLS = function(certs) {
    return Array.isArray(certs) && certs.length > 0;
  };

  export let data = [];

  export let renew = function() {
    let url = `${window.location.origin}/v1/routes`
    if (window.location.port === '5000') {
      url = "http://localhost:8080/v1/routes"
    }
    fetch(url)
      .then(function(res) {
        return res.json();
      })
      .then(function(json) {
        data = json._data;
        if (!data) {
          data = [];
        }
      });
  };

  export let trigger = function(listeners, service_cluster) {
    for (let i in listeners) {
      if (listeners[i].service_cluster !== service_cluster) {
        listeners[i].hide = !listeners[i].hide;
      }
    }
    data = listeners;
  };

  onMount(() => {
    renew();
  });
</script>

<style>
  .listenername {
    font-size: 16px;
    color: #fc7307;
    background: white;
  }

  .groupname {
    color: #0f4c75;
  }

  .headers {
    color: #236ab9;
    background: #d4e4f7;
  }

  .toprow {
    font-weight: bold;
    background: #bfd7f3;
  }

  .values {
    font-size: 12px;
    background: #eeeeee;
  }

  .highlight {
    color: #d14a9b;
  }

  .hide {
    visibility: hidden;
    opacity: 0;
    transition: visibility 0s, opacity 0.5s linear;
  }
</style>

<main>
  <div class="pa4 ph5-ns">

    <div class="fl w-10 pa2">
      <svg
        xmlns="http://www.w3.org/2000/svg"
        role="img"
        viewBox="0.58 -3.92 541.84 189.34">
        <style>
          svg {
            enable-background: new 0 0 543.6 182;
          }
        </style>
        <path
          d="M275 99.6c0 2.2.5 4.3 1.5 6.1s2.3 3.4 3.8 4.7c1.6 1.3 3.4 2.3 5.5 3
          2.1.7 4.3 1.1 6.5 1.1 3 0 5.7-.7 7.9-2.1 2.2-1.4 4.3-3.3 6.2-5.6l7.4
          5.6c-5.4 7-13 10.5-22.7 10.5-4
          0-7.7-.7-11-2.1-3.3-1.4-6.1-3.3-8.3-5.7-2.3-2.4-4-5.3-5.2-8.5-1.2-3.3-1.8-6.8-1.8-10.7
          0-3.8.7-7.4 2-10.7 1.3-3.3 3.2-6.1 5.5-8.5 2.3-2.4 5.1-4.3 8.4-5.7
          3.2-1.4 6.8-2.1 10.6-2.1 4.5 0 8.4.8 11.5 2.4s5.7 3.7 7.7 6.2c2 2.6
          3.5 5.4 4.4 8.7.9 3.2 1.4 6.5 1.4
          9.8v3.5H275zm30.8-7.8c-.1-2.2-.4-4.1-1-5.9-.6-1.8-1.5-3.4-2.8-4.7-1.2-1.3-2.8-2.4-4.6-3.1-1.8-.8-4-1.1-6.4-1.1-2.4
          0-4.6.5-6.5 1.4-2 .9-3.7 2.1-5 3.5-1.4 1.4-2.4 3-3.2 4.8-.8 1.8-1.1
          3.5-1.1 5.2h30.6zm18.8-21.4h9.7v7.9h.2c1.2-2.7 3.4-5 6.4-6.7 3-1.7
          6.5-2.5 10.5-2.5 2.5 0 4.8.4 7.1 1.1 2.3.8 4.3 1.9 5.9 3.5 1.7 1.6 3
          3.6 4.1 6.1 1 2.5 1.5 5.4 1.5
          8.8v33h-9.7V91.4c0-2.4-.3-4.4-1-6.1-.6-1.7-1.5-3.1-2.6-4.1-1.1-1-2.3-1.8-3.7-2.3-1.4-.5-2.9-.7-4.4-.7-2
          0-3.9.3-5.6 1-1.7.6-3.2 1.7-4.5 3.1-1.3 1.4-2.3 3.2-3 5.4-.7 2.2-1.1
          4.7-1.1 7.7v26.4h-9.7V70.4zm48.6 0h11.3l15.4 39.3 14.7-39.3H425l-20.1
          51.3H394l-20.8-51.3zM425.5 96c0-3.7.7-7.2 2.1-10.5 1.4-3.2 3.3-6.1
          5.8-8.5 2.5-2.5 5.3-4.4 8.7-5.8 3.3-1.4 6.9-2.1 10.7-2.1 3.8 0 7.4.7
          10.7 2.1 3.3 1.4 6.2 3.3 8.7 5.8 2.5 2.5 4.4 5.3 5.8 8.5 1.4 3.2 2.1
          6.7 2.1 10.5s-.7 7.3-2.1 10.5c-1.4 3.3-3.3 6.1-5.8 8.5-2.5 2.4-5.3
          4.3-8.7 5.7-3.3 1.4-6.9 2.1-10.7 2.1-3.8
          0-7.4-.7-10.7-2.1-3.3-1.4-6.2-3.3-8.7-5.7-2.5-2.4-4.4-5.3-5.8-8.5-1.4-3.2-2.1-6.7-2.1-10.5zm10.4
          0c0 2.6.4 5 1.2 7.2.8 2.2 1.9 4.1 3.4 5.6 1.4 1.6 3.2 2.8 5.3 3.7
          2.1.9 4.4 1.4 7 1.4 2.6 0 4.9-.4 7-1.4 2.1-.9 3.9-2.1 5.3-3.7s2.6-3.4
          3.4-5.6c.8-2.2 1.2-4.6 1.2-7.2
          0-2.6-.4-5-1.2-7.2-.8-2.2-1.9-4.1-3.4-5.6-1.4-1.5-3.2-2.8-5.3-3.7-2.1-.9-4.4-1.4-7-1.4-2.6
          0-4.9.5-7 1.4-2.1.9-3.9 2.1-5.3 3.7s-2.6 3.4-3.4 5.6c-.8 2.2-1.2
          4.6-1.2 7.2zm44.9-25.6H492l15.2 40h.2l14.6-40h10.4L508 132.7c-.9
          2.2-1.8 4.3-2.7 6.1-.9 1.8-2 3.4-3.3 4.7-1.3 1.3-2.9 2.3-4.7
          3-1.8.7-4.1 1.1-6.7 1.1-1.4
          0-2.9-.1-4.4-.3-1.5-.2-2.9-.6-4.3-1.1l1.2-8.9c1.9.8 3.9 1.2 5.8 1.2
          1.5 0 2.8-.2 3.8-.6 1-.4 1.9-1 2.7-1.7.8-.8 1.4-1.6 1.9-2.7.5-1 1-2.2
          1.5-3.5l3.2-8.1-21.2-51.5z" />
        <path
          d="M67.5 88.1l.3 13.6 14.3 8.9-.3-13.6zm34.9
          56.5l-.3-13.3-12.5-7.8c-.2-.1-.4-.3-.5-.4l.3 13.4 13 8.1zm-44.7
          17.9L25 142.3l-.8-34 16-6.9-.3-13.6-25.6 11c-2 .9-3.2 2.7-3.1 4.8l1
          40.8c0 2.1 1.3 4.2 3.4 5.4l39.3 24.3c1.8 1.1 4 1.4
          5.9.9.2-.1.4-.1.6-.2l24.1-10.4-13.1-8.1-14.7
          6.2zm105.8-75.2c-.1-2.4-1.5-4.9-3.9-6.3l-47.7-29.5-1.5.6.3 14.3 37.7
          23.4.9 38.2 14.4 8.9.8-.3-1-49.3z" />
        <path
          d="M106.4 154.5L62.2 127l-1.1-46 20.2-8.7-.4-15.9-31.4 13.5c-2.3 1-3.7
          3.1-3.6 5.6l1.3 54c0 2.5 1.5 4.9 3.9 6.3L103 168c2.1 1.3 4.7 1.7 6.9 1
          .2-.1.4-.2.6-.2l30.7-13.2-15.2-9.4-19.6 8.3z" />
        <path
          d="M231 49.5L164.4 8.3c-2.5-1.5-5.4-1.9-7.9-1.1-.2.1-.5.2-.7.3l-64.9
          28c-2.6 1.1-4.2 3.5-4.1 6.4l1.6 69.2c.1 2.8 1.8 5.6 4.5 7.2l66.5
          41.2c2.4 1.5 5.4 1.9 7.9 1.1.2-.1.5-.2.7-.3l64.9-28c2.6-1.1 4.2-3.6
          4.1-6.4l-1.6-69.2c0-2.8-1.7-5.5-4.4-7.2zM163.4 144l-57.8-35.8-1.5-60.2
          56.4-24.3 57.8 35.8 1.4 60.1-56.3 24.4z" />
      </svg>
    </div>
    <div class="fl w-50 pa9">
      <h1 class="fw6">Pilot</h1>
    </div>
    <div class="fl w-100 pa1">
      <hr />
    </div>

    <div class="fl w-100 pa2">
      <button class="f6 link dim ba ph3 pv2 mb2 dib dark-pink" on:click={renew}>
        Renew
      </button>
    </div>

    {#each data as group}
      <!-- <div class="fl w-100 ma2 pa2 ba b--dashed bw1"> -->
      <div class="fl w-100 ma2 pa2 ba b--dashed b--black-30 br3">
        <h3
          class="groupname"
          on:click={e => trigger(data, group.service_cluster)}>
          {group.service_cluster}
        </h3>

        {#if group.http_listeners}
          {#each group.http_listeners as listener}
            <table
              class="mb3 w-100 dt--fixed center {group.hide ? ' hide' : ''}">
              <tr>
                <th class="pv1 ph3 tl fw7 listenername">
                  HTTP - {listener.name}
                </th>
              </tr>
              <tr class="toprow">
                <th class="pv1 ph3">listening</th>
                {#if isTLS(listener.tls_files)}
                  <th class="pv1 ph3">crt</th>
                  <th class="pv1 ph3">key</th>
                {/if}
              </tr>
              <tr class="values tc">
                <td class="pv1 ph3">{listener.addr}:{listener.port}</td>
                {#if isTLS(listener.tls_files)}
                  <td class="pv1 ph3 tc">
                    {#each listener.tls_files as cert}
                      {cert.crt}
                      <br />
                    {/each}
                  </td>
                  <td class="pv1 ph3 tc">
                    {#each listener.tls_files as cert}
                      {cert.key}
                      <br />
                    {/each}
                  </td>
                {/if}
              </tr>

              <tr>
                <th class="pv1 ph3 toprow">routes</th>
                <th class="pv1 ph3 tc headers">domains</th>
                <th class="pv1 ph3 tr headers">path prefix</th>
                <th class="pv1 ph3 tl headers">prefix rewrite</th>
                <th class="pv1 ph3 headers">upstream</th>
                <th class="pv1 ph3 headers">timeout</th>
                <th class="pv1 ph3 headers">DNS type</th>
                <th class="pv1 ph3 headers">CORS</th>
              </tr>

              {#each listener.virtual_hosts as vh}
                <tr class="values">
                  <td class="pv1 ph3 tc">{vh.name}</td>
                  <td class="pv1 ph3 tc highlight">
                    {#each vh.domains as domain}
                      {domain}
                      <br />
                    {/each}
                  </td>
                  <td class="pv1 ph3 tr">
                    {#if vh.hasOwnProperty('route_rules') && vh.route_rules}
                      {#each vh.route_rules as rule}
                        {rule.path_prefix}
                        <br />
                      {/each}
                    {/if}
                  </td>
                  <td class="pv1 ph3 tl">
                    {#if vh.hasOwnProperty('route_rules') && vh.route_rules}
                      {#each vh.route_rules as rule}
                        {rule.prefix_rewrite}
                        <br />
                      {/each}
                    {/if}
                  </td>
                  <td class="pv1 ph3 tc">
                    {#if vh.hasOwnProperty('route_rules') && vh.route_rules}
                      {#each vh.route_rules as rule}
                        {rule.cluster.addr}:{rule.cluster.port}
                        <br />
                      {/each}
                    {/if}
                  </td>
                  <td class="pv1 ph3 tc">
                    {#if vh.hasOwnProperty('route_rules') && vh.route_rules}
                      {#each vh.route_rules as rule}
                        {#if rule.cluster.timeout === 0}
                          15 sec
                        {:else}
                          {rule.cluster.timeout / 1000} sec
                        {/if}
                        <br />
                      {/each}
                    {/if}
                  </td>
                  <td class="pv1 ph3 tc">
                    {#if vh.hasOwnProperty('route_rules') && vh.route_rules}
                      {#each vh.route_rules as rule}
                        {#if rule.cluster.dns_type === 'strict' ||
                             rule.cluster.dns_type === 'logical'}
                          {rule.cluster.dns_type}
                        {:else}
                          logical
                        {/if}
                        <br />
                      {/each}
                    {/if}
                  </td>
                  <td class="pv1 ph3 tc">
                    {#if vh.enable_cors}
                    V
                    {:else}
                    -
                    {/if}
                  </td>
                </tr>
              {/each}
            </table>
          {/each}
        {/if}

        {#if group.tcp_listeners}
          {#each group.tcp_listeners as listener}
            <table class="mb3 w-50 dt--fixed left">
              <tr>
                <th class="pv1 ph3 tl fw7 listenername">
                  TCP - {listener.name}
                </th>
              </tr>
              <tr class="toprow">
                <th class="pv1 ph3" colspan="1">listening</th>
                <th class="pv1 ph3">upstream</th>
              </tr>
              <tr class="values tc">
                <td class="pv1 ph3">{listener.addr}:{listener.port}</td>
                <td class="pv1 ph3 tc">
                  {#each listener.clusters as cluster}
                    {cluster.addr}:{cluster.port}
                    <br />
                  {/each}
                </td>
              </tr>
            </table>
          {/each}
        {/if}

      </div>
    {/each}

  </div>
</main>
